import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


// Components
import Home from "./components/Home";
import History from "./components/History";
import News from "./components/News";
import Contact from "./components/Contact";
import Menu from "./components/Menu";
import SiteFooter from "./components/SiteFooter";
import TermsAndConditions from "./components/TermsAndConditions";
import Administration from "./components/Administration";
import Accommodation from "./components/Accommodation";
import Timing from "./components/Timing";
import MainnMenu from "./components/MainMenu";
import Attract from "./components/Attract";
import PhotoGallery from "./components/PhotoGallery";
import Live from "./components/Live";
import Slider from "./components/Slider";
import NewsEvents from "./components/NewsEvents";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Ithihyam from "./components/Ithihyam";

function App() {
  return (

	
    <Router>
      {/* <!-- Header --> */}

	<header className="header">
			<MainnMenu />
		

		{/* <!-- Header Content --> */}
		{/* <div class="header_container headerbg">
			<div class="">
				<div class="row">
					<div class="row">
						<div class="header_content row">
							<div className="col-md-4">
								<div class="logo_container" style={{marginLeft:'95px'}}>
									
										<div class="logo_content d-flex flex-row align-items-end justify-content-start">
											<div ><img src="./images/spst-home-icon.png" alt="logo" className="homeimage"/></div>
										</div>
									
								</div>
							</div>
							<div className="col-md-8">
								<nav className="main_nav_contaner " style={{backgroundColor:'maroon',padding:'25px',borderRadius:'10px 0px 0px 10px',width:'100%',marginTop:'10px'}}>
								<ul className="flex space-x-6 text-white font-semibold_ main_nav menucol_" >
									
									<li className="active_ " ><Link to="/"><span className="items">home</span></Link></li>
									<li><Link to="History" className="items">History</Link></li>
									<li><Link to="https://booking.sreepadmanabhaswamytemple.org/"><span className="items">Online Booking</span></Link></li>
									<li><Link to="Timing"><span className="items">Darsan Time</span></Link></li>
									<li><Link to="Accommodation"><span className="items">Accommodation</span></Link></li>
									<li><Link to="Administration"><span className="items">Administration</span></Link></li>
									<li><Link to="Contact"><span className="items">Contact</span></Link></li>
									
				  					
								</ul>
								

								<div class="hamburger menu_mm">
									<i class="fa fa-bars menu_mm" aria-hidden="true"></i>
								</div>
							</nav>
							</div>
							

						</div>
					</div>
				</div>
			</div>
		</div> */}

		
		{/* <div class="header_search_container">
			<div class="container">
				<div class="row">
					<div class="col">
						<div class="header_search_content d-flex flex-row align-items-center justify-content-end">
							<form action="#" class="header_search_form">
								<input type="search" class="search_input" placeholder="Search" required="required" />
								<button class="header_search_button d-flex flex-column align-items-center justify-content-center">
									<i class="fa fa-search" aria-hidden="true"></i>
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>			
		</div>			 */}
	</header>

	{/* <!-- Menu --> */}

	
	
	{/* <!-- Home --> */}
	<div >
    	 {/* Page Routes */}
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
			 {/* <Route path="home" element={<Home />} /> */}
            <Route path="/history" element={<History />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/menu" element={<Menu />} />
			<Route path="/termsandconditions" element={<TermsAndConditions />} />
			<Route path="/administration" element={<Administration />} />
			<Route path="/timing" element={<Timing />} />
			<Route path="/attract" element={<Attract />} />
			<Route path="/gallery" element={<PhotoGallery />} />
			<Route path="/live" element={<Live />} />
			<Route path="/Slider" element={<Slider />} />
			<Route path="/newsevents" element={<NewsEvents />} />
			<Route path="/privacypolicy" element={<PrivacyPolicy />} />
			<Route path="/ithihyam" element={<Ithihyam />} />
			</Routes>
        </div>
      </div>


		<footer class="footer" style={{backgroundImage:'url(./images/devi.png)',backgroundPosition:'center', padding:'0px'}}>
			<SiteFooter />
		</footer>
    </Router>
  );
}






export default App;
